import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0e0db554&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0db554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0db554')) {
      api.createRecord('0e0db554', component.options)
    } else {
      api.reload('0e0db554', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0e0db554&scoped=true&", function () {
      api.rerender('0e0db554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/newProject/index.vue"
export default component.exports